const certifications = [
  {
    id: 1,
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/dbfe4d39-9bf9-40a6-8436-276352abdd59_IMG_0795.png?v=0eef0aa8a8df007c0102f0b57f7bf133',
    label: 'Attestation de Capacité',
  },
  {
    id: 2,
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/406946c2-f1b3-4af9-806e-4dfcd88196f7_IMG_0786.jpeg?v=9f4d0c11b7f47818b8127a115465ce21',
    label: 'Attestation d\'Aptitude à la manipulation des fluides frigorigènes',
  },
  {
    id: 3,
    img: 'https://storage.readdy-site.link/project_files/e4c7a492-de03-406b-a8a1-3da9791885bd/b39986aa-6436-4303-b4bf-593df00aec0d_IMG_0796.jpeg?v=1349e49e70173f38cde697c5201551a5',
    label: 'Responsabilité Civile + Assurance Décennale',
  },
];

const QualificationsSection = () => (
  <section className="w-full py-16 bg-[#f4f9fd]">
    <div className="max-w-5xl mx-auto px-6">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="flex items-center justify-center gap-3 mb-3">
          <div className="h-px w-12 bg-[#1a8abf]" />
          <span className="text-[#1a8abf] text-xs font-bold uppercase tracking-widest">
            Nos Accréditations
          </span>
          <div className="h-px w-12 bg-[#1a8abf]" />
        </div>
        <h2 className="text-2xl lg:text-3xl font-black text-[#002060]">
          Qualifications &amp; Certifications
        </h2>
        <p className="text-[#4a6272] text-sm mt-3 max-w-xl mx-auto">
          Des qualifications officielles qui attestent de notre expertise et de notre sérieux. Vous faites appel à des professionnels reconnus et certifiés.
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {certifications.map((cert) => (
          <div
            key={cert.id}
            className="rounded-2xl border border-[#e0eef8] bg-white overflow-hidden hover:border-[#1a8abf] transition-all duration-300"
          >
            {/* Full-image display with blurred backdrop */}
            <div className="relative w-full" style={{ height: 260 }}>
              {/* Blurred background */}
              <img
                src={cert.img}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 w-full h-full object-cover scale-110"
                style={{ filter: 'blur(14px)', opacity: 0.55 }}
              />
              {/* Sharp full image centered */}
              <img
                src={cert.img}
                alt={cert.label}
                className="absolute inset-0 w-full h-full object-contain"
              />
            </div>

            {/* Label */}
            <div className="px-5 py-4 flex items-center gap-3 border-t border-[#e8f2fa]">
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#e8f2fa]">
                <i className="ri-medal-line text-[#1a8abf] text-sm" />
              </div>
              <span className="text-[#002060] font-semibold text-sm">{cert.label}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom trust bar */}
      <div className="mt-10 flex flex-wrap justify-center gap-6">
        {[
          { icon: 'ri-shield-check-line', text: 'Techniciens certifiés' },
          { icon: 'ri-award-line', text: 'Qualifications à jour' },
          { icon: 'ri-verified-badge-line', text: 'Reconnu par les fabricants' },
        ].map((item) => (
          <div key={item.text} className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className={`${item.icon} text-[#1a8abf] text-base`} />
            </div>
            <span className="text-[#4a6272] text-sm font-medium">{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default QualificationsSection;
